import { requestWithAuth } from '@utilities/graphQLClient';
import { gql } from 'graphql-request';
import type { Watchlist, WatchlistItem } from '../useWatchlist/types';

interface WatchlistsItem {
  id: Watchlist['id'];
  name: Watchlist['name'];
  totalItems: Watchlist['totalItems'];
  itemsLimit: Watchlist['itemsLimit'];
  items: Pick<WatchlistItem, 'companyId'>[];
  keys: WatchlistItem['companyId'][];
}

export interface Response {
  watchlists: WatchlistsItem[];
  watchlistsKeys: WatchlistItem['companyId'][];
}

interface QueryResponse {
  Watchlists: WatchlistsItem[];
  errors?: Error[];
}

export const getDefaultWatchlistsResponse = (): Response => ({
  watchlists: [],
  watchlistsKeys: [],
});

export const mapWatchlistsItemToCache = (
  watchlist: Partial<WatchlistsItem>
): WatchlistsItem => ({
  id: watchlist.id ?? '',
  name: watchlist.name ?? '',
  totalItems: watchlist.totalItems ?? 0,
  itemsLimit: watchlist.itemsLimit ?? 50,
  items: watchlist.items ?? [],
  keys: watchlist.items?.map((n) => n.companyId) || [],
});

export const mapWatchlistsItemsToKeys = (watchlists: WatchlistsItem[]) =>
  watchlists
    .map((watchlist) => watchlist.items.map((item) => item.companyId))
    .flat();

export const queryFn = async (): Promise<Response> => {
  const response = await requestWithAuth<QueryResponse>(
    gql`
      query getWatchlists {
        Watchlists {
          id
          name
          totalItems
          itemsLimit
          items {
            companyId
          }
        }
      }
    `
  );
  const { Watchlists: watchlists, errors } = response;
  if (errors && errors.length > 0) {
    console.log(errors[0].message);
    throw new Error(errors[0].message);
  }

  const watchlistsWithKeys = watchlists.map(mapWatchlistsItemToCache);

  const watchlistsKeys = watchlistsWithKeys.reduce<WatchlistsItem['keys']>(
    (keys, watchlist) => [...keys, ...watchlist.keys],
    []
  );

  return { watchlists: watchlistsWithKeys, watchlistsKeys };
};
